import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import * as XLSX from 'xlsx';
import { Centre } from '../../../../interfaces/Centres';
import { FullChild } from '../../../../interfaces/FullChild';
import { CentreService } from '../../../../services/centre.service';
import { ChildService } from '../../../../components/child/child.service';
import {Timestamp} from "firebase/firestore";
import {PermissionType} from "../../../../components/employee/PermissionType.enum";


@Component({
  selector: 'app-hospital-report',
  templateUrl: './hospital-report.component.html',
  styleUrls: ['./hospital-report.component.scss']
})
export class HospitalReportComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  selectedCentre!: Centre | null;
  displayCentre = (c: any) => c?.centreName;
  displayedColumns: string[] = ['DoA','centreName', 'childName', 'hospital' ,'status'];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  fileName = 'Hospital_Report.xls';
  centres$: Observable<Centre[]>;
  hospitals: string[] = [];
  dataSource: MatTableDataSource<FullChild>;
  hospitalFilter: string = '';
  filterDate: any;

  constructor(
    private readonly mCentreService: CentreService,
    private readonly mChildService: ChildService
  ) {
    this.centres$ = this.mCentreService.getAllCentres();
    this.dataSource = new MatTableDataSource<FullChild>();
  }

  ngOnInit(): void {
  }

  onCentreSelect(selectedCentre: Centre | null) {
    this.selectedCentre = selectedCentre;

    if (!selectedCentre) {
      this.dataSource.data = [];
      this.hospitals = [];
      return;
    }

    console.log("Selected Centre:", selectedCentre);

    this.mSearch(); // Now run the search
  }



  // mSearch() {
  //   if (this.selectedCentre != null) {
  //     // Fetch hospitals based on selected centre
  //     this.mChildService.getChildListByCenter(this.selectedCentre.centreCode).subscribe(res => {
  //       console.log(res)
  //       this.dataSource.data = res;
  //       // Extract unique hospital names for dropdown
  //       this.hospitals = [...new Set(res.map(child => child.hospital))];
  //
  //       // Apply hospital filter if it's set
  //       if (this.hospitalFilter) {
  //         this.applyHospitalFilter(this.hospitalFilter);
  //       }
  //
  //       this.dataSource.paginator = this.paginator;
  //       this.dataSource.sort = this.sort;
  //     });
  //   }
  // }

  mSearch() {
    if (!this.selectedCentre) return;

    this.mChildService.getChildListByCenter(this.selectedCentre.centreCode)
      .pipe(takeUntil(this._destroyed$))
      .subscribe(res => {

        this.dataSource.data = res;

        // Extract unique hospitals
        this.hospitals = [...new Set(res.map(child => child.hospital || ''))];

        // Apply existing hospital filter if selected
        if (this.hospitalFilter) {
          this.applyHospitalFilter(this.hospitalFilter);
        }

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
  }

  getDate(date: any): Date {
    return (date as Timestamp).toDate();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  // applyHospitalFilter(filterValue: string) {
  //   this.hospitalFilter = filterValue.trim().toLowerCase();
  //   this.dataSource.filter = this.hospitalFilter;
  //
  //   if (this.dataSource.paginator) {
  //     this.dataSource.paginator.firstPage();
  //   }
  // }

  applyHospitalFilter(hospital: string) {
    this.hospitalFilter = hospital.toLowerCase();

    this.dataSource.filterPredicate = (data: FullChild, filter: string) =>
      (data.hospital || '').toLowerCase().includes(filter);

    this.dataSource.filter = this.hospitalFilter;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  exportexcel() {
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    ws['!cols'] = [];
    ws['!cols'][19] = { hidden: true };

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, this.fileName);
  }

  // Clear() {
  //   this.selectedCentre = null;
  //   this.hospitalFilter = '';
  //   this.dataSource.filter = '';
  //   this.dataSource = new MatTableDataSource();
  //
  // }

  Clear() {
    this.selectedCentre = null;
    this.hospitalFilter = '';

    this.hospitals = [];

    this.dataSource = new MatTableDataSource();

    // Reset filters
    this.dataSource.filter = '';

    // RESET SEARCHABLE-SELECT UI
    setTimeout(() => {
      this.selectedCentre = null;
    });
  }


  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  protected readonly PermissionType = PermissionType;
}
